package ru.it_mozaika.sender.common.models

import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule

val httpApiJson = Json {
    classDiscriminator = "___type"
    encodeDefaults = true
    isLenient = true
    allowSpecialFloatingPointValues = true
    allowStructuredMapKeys = true
    prettyPrint = false
    ignoreUnknownKeys = true
    serializersModule = SerializersModule {}

}